import HeightEqualizer from "@/ts/base/Utils/HeightEqualizer";

export default class EqualHeightElementCollection {
	protected container: HTMLElement | null = null;
	protected selector: string;
	protected delayedElementIds: string[];

	constructor(container?: HTMLElement | null, isInstant: boolean = false) {
		this.container = <HTMLElement | null>container;
		this.selector = this.getSelector();
		this.delayedElementIds = [];

		if (isInstant) {
			this.run();
		}
	}

	run(): void {
		this.matchHeight().finally(() => {
			this.afterMatchHeight();
		});
	}

	getSelector(): string {
		return "";
	}

	getComponents(): NodeListOf<HTMLElement>[] {
		return [];
	}

	matchHeight(): Promise<void> {
		return new Promise<void>(resolve => {

			let components = this.getComponents();
			let numMatched = 0;

			components.forEach(els => {
				if (els.length > 0) {
					new HeightEqualizer(els);
					els.forEach(el => {
						el.addEventListener(HeightEqualizer.FinishEvent, e => {
							numMatched++;
							if (numMatched === components.length) {
								setTimeout(() => {
									resolve();
								}, 50);
							}
						});
					});
				}
			});
		});
	}

	afterMatchHeight(): void {

	}

	protected onWindowScroll(evt: Event): void {
		this.afterMatchHeight();
	}
}
